import { gql } from '@apollo/client';

export const RECORDING_JSON = gql`
  query RecordingJson($getMyRecordingId: MongoObjectID!) {
    getMyRecording(id: $getMyRecordingId) {
      id
      recordingStartedAt
      comment
      analysis {
        id
        annotations {
          sampleIndex
          annotationValue
        }
      }
      # Single channel (project_management#529).
      json {
        ch1
      }
      pointComments {
        id
        recordingId
        sampleIndex
        comment
      }
    }
  }
`;
